import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Platform } from '@ionic/angular';
import { appConfig } from 'src/app/config/app.config';
import { Relative } from 'src/app/models/Relative';
import { AuthService } from 'src/app/services/auth.service';
import { EmployeeSService } from 'src/app/services/modelService/employeeS.service';
import { RelativeService } from 'src/app/services/modelService/relative.service';
import { TranslateService } from 'src/app/services/translate.service';
import { VaniService } from 'src/app/services/vani.service';
import { ToastService } from 'src/app/util/toast.service';
import { UtilityService } from 'src/app/util/utility.service';
import { CountryService } from 'src/app/services/country.service';

@Component({
  selector: 'app-slide3',
  templateUrl: './slide3.component.html',
  styleUrls: ['./slide3.component.scss'],
})
export class Slide3Component implements OnInit {
  utilityService: UtilityService = new UtilityService();
  isLive: boolean = true;
  dob: string;
  minDate: string;
  maxDate: string;
  objectKeys = Object.keys;
  isMobileLogin: boolean = false;
  isEmailLogin: boolean = false;
  @Output() mobileBlur = new EventEmitter<string>();
  @Input() invitee: any;
  @Input() session: any;
  constructor(private empService: EmployeeSService,
    public trans: TranslateService,
    private relativeService: RelativeService,
    public auth: AuthService,
    public toastService: ToastService,
    public platform: Platform,
    private vani: VaniService,
    public countryService: CountryService,
  ) {
    this.trans.translateObjList(this.utilityService.educationObjectList);
  }

  ngOnInit() {
    const currentDate = new Date();
    this.maxDate = currentDate.toISOString().split('T')[0];

    // Parse mobile number if it contains country code
    if (this.auth.loggedInEmployee?.user?.user_pd?.mobile && this.auth.loggedInEmployee.user.user_pd.mobile.startsWith('+')) {
      const parsed = this.countryService.parsePhone(this.auth.loggedInEmployee.user.user_pd.mobile);
      if (parsed) {
        this.auth.loggedInEmployee.user.user_pd.country_code = parsed.countryCode;
        this.auth.loggedInEmployee.user.user_pd.mobile = parsed.number;
      }
    } else if (this.auth.loggedInEmployee?.user?.user_pd && !this.auth.loggedInEmployee.user.user_pd.country_code) {
      this.auth.loggedInEmployee.user.user_pd.country_code = '+91'; // Default
    }

    setTimeout(() => {
      if (this.auth.loggedInEmployee?.user?.user_pd) {
        this.auth.loggedInEmployee.user.user_pd.privacy = "Hide Contact Info";

        // Detect login method
        if (this.auth.loggedInEmployee.user.user_pd.mobile && !this.auth.loggedInEmployee.user.user_pd.email) {
          this.isMobileLogin = true;
          this.isEmailLogin = false;
        } else if (this.auth.loggedInEmployee.user.user_pd.email && !this.auth.loggedInEmployee.user.user_pd.mobile) {
          this.isEmailLogin = true;
          this.isMobileLogin = false;
        } else if (this.auth.loggedInEmployee.user.user_pd.email && this.auth.loggedInEmployee.user.user_pd.mobile) {
          this.isMobileLogin = true;
          this.isEmailLogin = true;
        }
      }
      this.vani.read("Fill your mandatory details")
    }, 200);

  }


  afterUpload(url) {
    console.log(url);
    this.auth.loggedInEmployee.user.url = url;
    this.empService.saveUser(appConfig.STORAGE_TABLE.USER, this.auth.loggedInEmployee.user).then(() => {
      this.relativeService.getRelative(this.auth.loggedInEmployee.id, "relative_id").then(async (relativeList: Relative[]) => {
        for (let relative of relativeList) {
          relative.url = url;
        }
        await this.relativeService.saveObjectList(relativeList);
      });
    });
  }

  onBlurMobile() {
    if (!this.auth.loggedInEmployee.user.user_pd.mobile || this.auth.loggedInEmployee.user.user_pd.mobile.trim().length === 0) {
      this.auth.loggedInEmployee.user.user_pd.mobile = null;
    }
    if (this.auth.loggedInEmployee.user.user_pd.mobile) {
      if (this.auth.loggedInEmployee.user.user_pd.mobile.startsWith("+")) {
        this.mobileBlur.emit(this.auth.loggedInEmployee.user.user_pd.mobile);
      } else {
        this.auth.loggedInEmployee.user.user_pd.mobile = this.auth.loggedInEmployee.user.user_pd.country_code + this.auth.loggedInEmployee.user.user_pd.mobile;
        this.mobileBlur.emit(this.auth.loggedInEmployee.user.user_pd.mobile);
      }
    }
  }

  onInputBlur(variable) {
    if (variable == 'name') {
      if (!this.auth.loggedInEmployee.user.name || this.auth.loggedInEmployee.user.name.length == 0) {
        this.vani.read("Name is mandatory");
        return;
      }
      let arr = this.auth.loggedInEmployee.user.name.split(" ");
      if (arr[arr.length - 1].toUpperCase() == "JI") {
        this.vani.read("Don't add Ji, System will add Ji as name suffix to everyone");
      }
    }
  }
}
